import { Container, Nav, Navbar, Image, Button } from "react-bootstrap";
import "./CustomNavbar.css";
import { NavLink, Link } from "react-router-dom";

export default function CustomNavbar() {
    return (
        <Navbar variant="custom" expand="lg" className="bg-body-tertiary">
            <Container>
                <Navbar.Brand as={Link} to="/">
                    <Image
                        width="170px"
                        src="https://boac-website.s3.eu-central-1.amazonaws.com/logo.png"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto align-items-center">
                        <Nav.Link as={NavLink} to="/" end>
                            Anasayfa
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/urunlerimiz">
                            Ürünlerimiz
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/hakkimizda">
                            Hakkımızda
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/franchise">
                            Franchise
                        </Nav.Link>
                        <Button as={Link} to="/etkinliklerde-boac" variant="primary">
                            Etkinliklerde BOAC
                        </Button>
                        <Nav.Link as={NavLink} to="/iletisim">
                            İletişim
                        </Nav.Link>
                    </Nav>
                    <Button as={Link} to="/boac-nerede" variant="primary">
                        BOAC Nerede?
                    </Button>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}
